$(document).ready(function(){
  // ============================minicart==============================

  refreshHeigh();

  $(window).resize(function(){
    setTimeout(function() {
      refreshHeigh();
      $('.cartDrawer').css("height", window.innerHeight+'px');
    }, 50); 
  });

  function refreshHeigh() {
    var bh = parseInt($('.cartButtonOuter').height()+80);
    var extrabh = parseInt($('.extra-checkout-buttons').innerHeight());
    var vh = $(window).height();    
    var newh = vh-bh+5;
    var qih = $('.quick-items').height();

    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 165) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }
  function addToCartSuccess() {
    $.get( "/cart?view=mini-cart", function( data ) {
      $('#cart').html(data);
      $('#cart').removeClass('loading');
      setTimeout(function() {
        refreshHeigh();
      }, 100);
    });

  }

  $('.cart-inner').on('click',function(e){
    e.preventDefault();
    $('body').addClass('cartOpen');
    $('.PageOverlay').addClass('is-visible');
    $('.fullPage').addClass('witmenu');
    $('header').addClass('cartOpen');
    $('.main-wrapper').addClass('cartOpen');
  });

  function refreshCart(count) {
    $.getJSON('/cart.js', function(cart){
      $('.cart_count').text(cart.item_count);
    });
  }

  $('body').on('click','#add-to-cart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    form.find('.error').remove();
    btn.attr('disabled', 'disabled');
    btn.text('Added');
    form.find('.error').remove();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('Add to Cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('Add to Cart');
      btn.removeAttr('disabled');
      refreshCart();
      $('.overlayquick').removeClass('active');
      $('.productGrid .productItem').removeClass('qvopen');
      $('body').addClass('cartOpen');
      $('.PageOverlay').addClass('is-visible');
      $('.fullPage').addClass('witmenu');
      $('header').addClass('cartOpen');
      $('.main-wrapper').addClass('cartOpen');
    });

  });


  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    $('#cart').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#cart').removeClass('loading');
      },
      success: function(){
        addToCartSuccess();
        refreshCart();
        $('#cart').removeClass('loading');
      }
    });

  });
  $("#cart").on('click', "a.remove_item", function(r){
    //alert('loading');
    $('#cart').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cart_count').text(c.item_count);
      if(!c.item_count) {
        $('.itemCount').text('0');
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
      }else {
        addToCartSuccess();
        $('#crt').removeClass('loading');
      }
    });
  });

  $('body').on('click','.closecart,.menu-overlay', function(e){
    e.preventDefault();
    $('body').removeClass('cartOpen');
    $('header').removeClass('cartOpen');
    $('.main-wrapper').removeClass('cartOpen');
  });
});